import React from 'react';
import { motion } from 'framer-motion';
import aboutImage from '../images/hotelmegha.jpg';
import '../css/section.css';


const Megha = () => {
   const fadeInUp = {
    hidden: { opacity: 0, y: -40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  const slideInLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  };

  const slideInRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  };
  return (
    <div className="container my-5">
      <h1 className="display-4 text-center mb-4">Hotel Megha</h1>
      <hr className="my-4" />

<section className="py-5 aboutsection white-text-section" id="about" aria-labelledby="about-heading">
      <div className="container">
        {/* Section Header */}
        <motion.div
          className="text-center mb-5"
          initial="hidden"
          whileInView="visible"
          variants={fadeInUp}
          viewport={{ once: true, amount: 0.3 }}
        >
         

        </motion.div>

        {/* Content Row */}
        <div className="row g-4 align-items-center">
          {/* Image */}
          <motion.div
            className="col-md-6"
            initial="hidden"
            whileInView="visible"
            variants={slideInLeft}
            viewport={{ once: true, amount: 0.2 }}
          >
            <img
              src={aboutImage}
              alt="Interior design showcase"
              className="img-fluid rounded shadow"
            />
          </motion.div>

          {/* Text Content */}
          <motion.div
            className="col-md-6"
            initial="hidden"
            whileInView="visible"
            variants={slideInRight}
            viewport={{ once: true, amount: 0.2 }}
          >
            <h3 className="h4 fw-semibold mb-3">ABOUT Hotel Megha</h3>
            <p className="mb-4">
             Hotel Megha is a luxurious haven of elegance and comfort 🌟🏨, nestled in the heart of the city 🌆. Renowned for its world-class service and opulent ambiance 🛋️✨, this five-star destination offers guests an unforgettable stay. The rooms and suites are exquisitely designed, blending modern sophistication with timeless charm 🛌🖼️. Guests can indulge in culinary delights 🍽️ from around the world at the hotel’s award-winning restaurants, or unwind with a refreshing cocktail at the rooftop bar 🍸🌇, boasting panoramic city views.
            </p>

            <h3 className="h4 fw-semibold mb-3">Why Choose US</h3>
            <p className="mb-4">
             At Hotel Majestic i we understand the importance of every detail. From the grandeur of our hall to the personalized service we provide, our goal is to make your event extraordinary and memorable. Trust us to handle your special occasion with the utmost care and expertise.
            </p>

           
          </motion.div>
        </div>
      </div>
    </section>



      {/* Rooms Section */}
      <section className="mb-5">
        <h2 className="h3 mb-3">🏨 Our Rooms</h2>
        <p className="lead">
          At Hotel Megha, we combine elegance and comfort to offer a memorable stay for all our guests. Choose from our thoughtfully designed room categories:
        </p>
        <h3 className="h4 mt-4">Room Categories</h3>
        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <thead className="table-dark">
              <tr>
                <th scope="col">Room Type</th>
                <th scope="col">Number of Rooms</th>
                <th scope="col">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Deluxe Rooms</td>
                <td>27</td>
                <td>Spacious, stylishly furnished, and equipped with premium amenities for a luxurious experience.</td>
              </tr>
              <tr>
                <td>Budget Rooms</td>
                <td>8</td>
                <td>Clean, cozy, and cost-effective — perfect for travelers looking for comfort on a budget.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Amenities Section */}
      <section>
        <h2 className="h3 mb-3">✨ Our Services & Amenities</h2>
        <p className="lead">Experience seamless hospitality with a wide range of modern facilities:</p>

        <h3 className="h4 mt-4">✅ General Amenities</h3>
        <ul className="list-group list-group-flush mb-4">
          <li className="list-group-item">Free High-Speed Wi-Fi</li>
          <li className="list-group-item">Centralized Air Conditioning</li>
          <li className="list-group-item">24x7 Power Backup</li>
          <li className="list-group-item">Lift/Elevator Access</li>
          <li className="list-group-item">Daily Housekeeping</li>
          <li className="list-group-item">Round-the-Clock Room Service</li>
        </ul>

        <h3 className="h4 mt-4">🚗 Parking</h3>
        <ul className="list-group list-group-flush mb-4">
          <li className="list-group-item">Onsite Guest Parking</li>
          <li className="list-group-item">Safe & Monitored Parking Area</li>
        </ul>

        <h3 className="h4 mt-4">🍽️ Dining</h3>
        <ul className="list-group list-group-flush mb-4">
          <li className="list-group-item">In-house Kitchen Facility</li>
          <li className="list-group-item">Fresh Meals Cooked to Order</li>
          <li className="list-group-item">In-Room Dining Available</li>
          <li className="list-group-item">Vegetarian and Non-Vegetarian Options</li>
        </ul>

        <h3 className="h4 mt-4">👨‍🍳 Staff & Support</h3>
        <ul className="list-group list-group-flush mb-4">
          <li className="list-group-item">Professional and Courteous Staff</li>
          <li className="list-group-item">24-Hour Front Desk Assistance</li>
          <li className="list-group-item">Trained Housekeeping Team</li>
        </ul>

        <h3 className="h4 mt-4">🔐 Safety & Security</h3>
        <ul className="list-group list-group-flush mb-4">
          <li className="list-group-item">CCTV Monitoring in Common Areas</li>
          <li className="list-group-item">Fire Safety Compliance</li>
          <li className="list-group-item">Electronic Key/Card Access (if available)</li>
        </ul>

        <h3 className="h4 mt-4">💼 Business & Additional Services</h3>
        <ul className="list-group list-group-flush mb-4">
          <li className="list-group-item">Welcoming Lobby Area</li>
          <li className="list-group-item">Local Travel Support on Request</li>
          <li className="list-group-item">Nearby Access to Local Transport and Markets</li>
        </ul>
      </section>



      <center>   <a href='https://www.google.com/travel/hotels/Megha%20Hotel%2C%20Pan%20Dariba%20Marg%2C%20near%20Khalsa%20Hospital%2C%20Cash%20and%20Pay%20Colony%2C%20Charbagh/entity/CgsI8bWBiMLyyN62ARAB?ts=CAESCgoCCAMKAggDEAAaIAoCGgASGhIUCgcI6Q8QBhgYEgcI6Q8QBhgZGAEyAhAAKgkKBToDSU5SGgA&utm_campaign=sharing&utm_medium=native&utm_source=htls&shem=hmpsa&sf=car&ved=0CAAQ5JsGahcKEwiQ-6q174uOAxUAAAAAHQAAAAAQBA' className='text-center btn btn-success'>Book Megha Hotels</a></center>

      <br />     <br />


    </div>
  );
};

export default Megha;